import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { MdWhatsapp } from 'react-icons/md'
import { Clinica } from './data'
import { styles } from './styles'

const TelaHome = ({ onAvancar }) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <>
      <Box
        sx={{
          flex: 1,
          overflow: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4,
          px: 3,
          backgroundColor: 'white',
        }}
      >
        <Grid container spacing={4} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: { xs: 'center', md: 'flex-end' },
              }}
            >
              <Box
                sx={{
                  borderRadius: 2,
                  p: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 2,
                }}
              >
                <img
                  src={isDesktop ? Clinica.logoHorizontalUrl : Clinica.logoUrl}
                  alt={Clinica.nome}
                  loading="lazy"
                  decoding="async"
                  style={{
                    width: isDesktop ? 400 : 200,
                    height: 'auto',
                    objectFit: 'contain',
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none'
                  }}
                />
              </Box>
              <Typography
                variant="h2"
                sx={{
                  color: '#59a68d',
                  fontWeight: 700,
                  mb: 1,
                  textAlign: { xs: 'center', md: 'right' },
                }}
              >
                {Clinica.nome}
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ mb: 1, textAlign: { xs: 'center', md: 'right' } }}
              >
                {Clinica.cnpj}
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ textAlign: { xs: 'center', md: 'right' } }}
              >
                {Clinica.especialidade}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: { xs: 'center', md: 'flex-start' },
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                sx={styles.primaryButton}
                fullWidth
                onClick={onAvancar}
              >
                Agende agora
              </Button>

              <Button
                variant="contained"
                sx={styles.secondaryButton}
                fullWidth
                startIcon={<MdWhatsapp />}
                href={`https://wa.me/${Clinica.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box sx={styles.footer}>3Sync Apps</Box>
    </>
  )
}

export default TelaHome
